import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminControlPanel = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const menuItems = [
    { 
      icon: '/admin_dashboard/icons/rag-management.png', 
      fallback: '🔍',
      title: 'RAG Management', 
      path: '/admin/controlpanel/rag', 
      color: '#004a97',
      description: 'Manage knowledge base content, scrape websites, and ingest data into vector databases for AI responses.'
    },
    { 
      icon: '/admin_dashboard/icons/prompt.png', 
      fallback: '✏️',
      title: 'Prompt Management', 
      path: '/admin/controlpanel/prompts', 
      color: '#0066cc',
      description: 'Customize AI prompts, agent behaviors, and response tones for different scenarios and languages.'
    },
    { 
      icon: '/admin_dashboard/icons/guardrails.png', 
      fallback: '🛡️',
      title: 'Guardrails', 
      path: '/admin/controlpanel/guardrails', 
      color: '#004a97',
      description: 'Configure safety settings, content filtering, and compliance rules to ensure appropriate AI responses.'
    },
    { 
      icon: '/admin_dashboard/icons/history.png', 
      fallback: '💬',
      title: 'Conversations', 
      path: '/admin/controlpanel/conversations', 
      color: '#0066cc',
      description: 'Review customer conversations, analyze chat history, and export conversation data for insights.'
    },
    { 
      icon: '/admin_dashboard/icons/agent_dashboard.png', 
      fallback: '🎛️',
      title: 'Agent Dashboard', 
      path: '/admin/dashboard', 
      color: '#004a97',
      description: 'Control AI agents, toggle maintenance mode, monitor system status, and manage agent performance.'
    },
    { 
      icon: '/admin_dashboard/icons/tester.png', 
      fallback: '🤖',
      title: 'Automated Tester', 
      path: '/admin/controlpanel/tester', 
      color: '#0066cc',
      description: 'Run automated tests with different customer personas to validate chatbot responses and behavior.'
    }
  ];

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f0f4f8',
      display: 'flex'
    }}>
      {/* Left Sidebar */}
      <div style={{
        width: sidebarOpen ? '280px' : '60px',
        backgroundColor: '#004a97',
        transition: 'width 0.3s ease',
        position: 'fixed',
        height: '100vh',
        zIndex: 1000,
        boxShadow: '2px 0 10px rgba(0,74,151,0.2)'
      }}>
        {/* Toggle Button */}
        <div style={{
          padding: '20px',
          borderBottom: '1px solid #0066cc',
          display: 'flex',
          alignItems: 'center',
          justifyContent: sidebarOpen ? 'space-between' : 'center'
        }}>
          {sidebarOpen && (
            <div style={{ color: 'white', fontWeight: 'bold', fontSize: '16px' }}>
              Jazeera Airways Admin
            </div>
          )}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              fontSize: '20px',
              cursor: 'pointer',
              padding: '5px'
            }}
          >
            {sidebarOpen ? '←' : '☰'}
          </button>
        </div>

        {/* Menu Items */}
        <div style={{ padding: '20px 0' }}>
          {menuItems.map((item, index) => (
            <div
              key={index}
              onClick={() => navigate(item.path)}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '15px 20px',
                color: 'white',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                borderLeft: '3px solid transparent'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#0066cc';
                e.currentTarget.style.borderLeftColor = '#ffffff';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.borderLeftColor = 'transparent';
              }}
            >
              <img 
                src={item.icon} 
                alt={item.title}
                style={{ 
                  width: '20px', 
                  height: '20px', 
                  minWidth: '20px',
                  filter: 'brightness(0) invert(1)'
                }}
                onError={(e) => {
                  console.log('Failed to load icon:', e.target.src);
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'inline';
                }}
              />
              <span style={{ 
                fontSize: '20px', 
                minWidth: '20px',
                display: 'none'
              }}>
                {item.fallback}
              </span>
              {sidebarOpen && (
                <span style={{ marginLeft: '15px', fontSize: '14px', fontWeight: '500' }}>
                  {item.title}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div style={{ 
        marginLeft: sidebarOpen ? '280px' : '60px',
        flex: 1,
        transition: 'margin-left 0.3s ease',
        padding: '40px 20px'
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(90deg, #004a97 0%, #0066cc 100%)',
          padding: '30px',
          color: 'white',
          borderRadius: '12px',
          marginBottom: '30px',
          boxShadow: '0 4px 12px rgba(0, 74, 151, 0.2)'
        }}>
          <h1 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold' }}>Jazeera Airways AI Assistant</h1>
          <p style={{ margin: '8px 0 0', opacity: 0.9, fontSize: '16px' }}>Administrative Control Panel</p>
          <p style={{ margin: '5px 0 0', opacity: 0.7, fontSize: '14px' }}>Manage your AI-powered customer service platform</p>
        </div>
        <div style={{
          maxWidth: '1200px',
          width: '100%'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '30px',
            boxShadow: '0 4px 12px rgba(0, 74, 151, 0.1)',
            border: '1px solid #e2e8f0'
          }}>
            <h2 style={{ 
              margin: '0 0 20px', 
              color: '#004a97',
              fontSize: '24px',
              fontWeight: '700',
              borderBottom: '2px solid #004a97',
              paddingBottom: '10px'
            }}>Admin Panel Features</h2>
            
            <p style={{
              color: '#718096',
              fontSize: '16px',
              marginBottom: '30px',
              lineHeight: '1.6'
            }}>
              Welcome to the Jazeera Airways AI Assistant Control Panel. Use the sidebar navigation to access different management modules. Each module provides comprehensive tools to configure and monitor your AI-powered customer service system.
            </p>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
              gap: '20px',
              marginTop: '20px'
            }}>
              {menuItems.map((item, index) => (
                <div key={index} style={{
                  backgroundColor: '#f8fafc',
                  border: `2px solid ${item.color}`,
                  borderRadius: '8px',
                  padding: '20px',
                  transition: 'all 0.2s ease'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '12px'
                  }}>
                    <img 
                      src={item.icon} 
                      alt={item.title}
                      style={{ 
                        width: '24px', 
                        height: '24px', 
                        marginRight: '12px'
                      }}
                      onError={(e) => {
                        console.log('Failed to load icon:', e.target.src);
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'inline';
                      }}
                    />
                    <span style={{ 
                      fontSize: '24px', 
                      marginRight: '12px',
                      display: 'none'
                    }}>
                      {item.fallback}
                    </span>
                    <h3 style={{
                      margin: 0,
                      color: item.color,
                      fontSize: '18px',
                      fontWeight: 'bold'
                    }}>
                      {item.title}
                    </h3>
                  </div>
                  <p style={{
                    margin: 0,
                    color: '#4a5568',
                    fontSize: '14px',
                    lineHeight: '1.5'
                  }}>
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
            
            <div style={{
              marginTop: '30px',
              padding: '20px',
              backgroundColor: '#e6f3ff',
              border: '1px solid #004a97',
              borderRadius: '8px'
            }}>
              <h3 style={{
                margin: '0 0 10px',
                color: '#004a97',
                fontSize: '16px',
                fontWeight: 'bold'
              }}>
                ℹ️ Getting Started
              </h3>
              <p style={{
                margin: 0,
                color: '#2d3748',
                fontSize: '14px',
                lineHeight: '1.5'
              }}>
                Click on any menu item in the left sidebar to access the corresponding management module. Each module is designed to help you configure and optimize your Jazeera Airways AI Assistant for the best customer experience.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Chat Button */}
      <div style={{
        position: 'fixed',
        bottom: '30px',
        right: '30px',
        zIndex: 1000
      }}>
        <button style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          backgroundColor: '#004a97',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          color: 'white',
          boxShadow: '0 4px 20px rgba(0, 74, 151, 0.3)',
          transition: 'all 0.3s ease'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.backgroundColor = '#0066cc';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.backgroundColor = '#004a97';
        }}
        title="Chat with J9 AI"
        >
          💬
        </button>
      </div>
    </div>
  );
};

export default AdminControlPanel;